module.exports = __webpack_public_path__ + "img/CatalanFlag.904cf9e6.png";